import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, { notify } from "react-notify-toast";
import { dateToRequestDate } from "../../../core/date";

const PeriodoModal = ({ show, handleClose, callback }) => {

    const loadingBtn = require("../../../assets/loaders/btn-loading.gif");

    const [cookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
    const [anho, setAnho] = useState('');
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    };

    const handleSave = () => {
        const body = {
            data: {
                anho: anho,
                fecha_inicio: fechaInicio ? dateToRequestDate(fechaInicio) : fechaInicio,
                fecha_fin: fechaFin ? dateToRequestDate(fechaFin) : fechaFin,
                id_estancia: cookie.kUserSession.data["farm"].id
            }
        };
        setLoading(true);
        axios.post(process.env.REACT_APP_API_URL + "periodos", body, prepareHeaders()).then(rs => {
            setLoading(false);
            callback();
            handleClose();
            notify.show("Periodo creado exitosamente", "success");
        }).catch(error => {
            console.error(error);
            setLoading(false);
            handleClose();
            notify.show("Ha ocurrido un error al crear el periodo", "error");
        });
    };

    return (
        <>
            <Notifications />
            <Modal show={show} onHide={handleClose} size="md">
                <Modal.Header closeButton>
                    <Modal.Title><b>Nuevo periodo</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="anho">
                                    <Form.Label>Año</Form.Label>
                                    <Form.Control className="karanda-input" value={anho} onChange={(e) => setAnho(e.target.value)} type="number" placeholder="Ingrese el año" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="fechaInicio">
                                    <Form.Label>Fecha inicio</Form.Label>
                                    <Form.Control className="karanda-input" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} type="date" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="fechaFin">
                                    <Form.Label>Fecha fin</Form.Label>
                                    <Form.Control className="karanda-input" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} type="date" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSave}>
                        { loading ? <img src={loadingBtn} height="15"/> : <span>Registrar</span> }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PeriodoModal;
